module.exports = __webpack_public_path__ + "img/atalanta-bc.f73138d3.png";